import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { SharedConsts } from '../../../shared/constants';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FILTER_INITIAL_STATE,
  FILTER_TAG_NAME_STATE,
  SELECTED_FILTER_VALUE,
} from '../../constants';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-sidebar-filters',
  standalone: false,
  templateUrl: './sidebar-filters.component.html',
  styleUrls: [
    './sidebar-filters.component.scss',
    '../suggested-products/suggested-products.component.scss',
  ],
})
export class SidebarFiltersComponent {
  filterSelectedValues: any = { ...SELECTED_FILTER_VALUE };
  filterInitialState: any = { ...FILTER_INITIAL_STATE };
  filterTagNames: any = { ...FILTER_TAG_NAME_STATE };
  list_value: any = { 0: '', 1: '1', 2: '0' };

  @Input() pmpProduct: Array<any> = [];
  @Input() promotionFilter: Array<any> = [];
  @Input() brandFilter: Array<any> = [];
  @Input() options: any;
  @Input() rspMin: any;
  @Input() rspMax: any;
  @Input() range!: string;
  @Output() removeAllFilters = new EventEmitter();
  @Output() onViewAllBrands = new EventEmitter();
  @Output() emitFiltersApplied = new EventEmitter();
  @Output() emitTagNamesApplied = new EventEmitter();

  searchBrandText: string = '';

  filterSelected: number = 0;
  has_searched_text: boolean = false;
  sticky: boolean = true;
  defaultMaxRspValue: number = 0;
  defaultMinRspValue: number = 0;

  searchInput = new Subject<string>();

  constructor(
    private statePersist: StatePersistService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public bsModalService: BsModalService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {}

  ngOnInit(): void {
    this.checkIfSelectedFilterValues();
  }

  //--------------on load check if filters were already applied--------------------------------------
  checkIfSelectedFilterValues(): void {
    const productData = this.statePersist.getLocalStorage('product_data');
    if (productData?.price_marked) {
      if (productData?.price_marked == '') {
        this.filterSelectedValues.selectedPmpProductValue = 0;
        this.filterInitialState['price_marked'] = 0;
      } else if (productData?.price_marked == '0') {
        this.filterSelectedValues.selectedPmpProductValue = 2;
        this.filterInitialState['price_marked'] = 2;
      } else {
        this.filterSelectedValues.selectedPmpProductValue = 1;
        this.filterInitialState['price_marked'] = 1;
      }
      this.filterTagNames = {
        ...this.filterTagNames,
        pmpTagName: this.createTagForPmp(),
      };
    }

    if (productData?.promotion_filter) {
      this.filterSelectedValues.promotionSelected =
        productData?.promotion_filter;
      this.filterInitialState['promotion_filter'] =
        productData?.promotion_filter;
    }

    if (productData?.brand_filter) {
      this.filterSelectedValues.brandSelected = productData?.brand_filter;
      this.filterInitialState['brand_filter'] = productData?.brand_filter;
    }

    if (productData?.range) {
      this.range = productData.range;
    }

    if (
      productData.rsp_min &&
      productData.rsp_min != '' &&
      productData.rsp_min != 0
    ) {
      this.filterSelectedValues.rspMinValue = parseFloat(productData?.rsp_min);
      this.filterInitialState['rsp_min'] = parseFloat(productData?.rsp_min);
    } else {
      this.filterSelectedValues.rspMinValue = 0;
    }

    if (
      productData.rsp_max &&
      productData.rsp_max != '' &&
      productData.rsp_max != 5
    ) {
      this.filterSelectedValues.rspMaxValue = parseFloat(productData?.rsp_max);
      this.filterInitialState['rsp_max'] = parseFloat(productData?.rsp_max);
    } else {
      this.filterSelectedValues.rspMaxValue = 5;
    }
  }

  ngOnChanges(simple): void {
    if (simple.brandFilter && simple.brandFilter.currentValue.length) {
      this.filterTagNames = {
        ...this.filterTagNames,
        brandTagName: this.createTagForSelectedBrand(),
      };
    }

    if (simple.promotionFilter && simple.promotionFilter.currentValue.length) {
      this.filterTagNames = {
        ...this.filterTagNames,
        promotionTagName: this.createTagForPromotions(),
      };
    }

    if (
      simple.rspMax &&
      simple.rspMax.currentValue &&
      simple.rspMax.currentValue != simple.rspMax.previousValue
    ) {
      this.filterSelectedValues.rspMaxValue = simple.rspMax.currentValue;
      this.defaultMaxRspValue = simple.rspMax.currentValue;
    }
    if (
      simple.rspMin &&
      simple.rspMin.currentValue &&
      simple.rspMin.currentValue != simple.rspMin.previousValue
    ) {
      this.filterSelectedValues.rspMinValue = simple.rspMin.currentValue;
      this.defaultMinRspValue = simple.rspMin.currentValue;
    }
    this.onEmitAppliedTagNames();
    this.checkFilterCount();
  }

  //-----------------on range filter select--------------------------------------------------
  selectRange(event: any): void {
    if (event.target.checked) {
      this.range = '1';
    } else {
      this.range = '0';
    }
    this.googleAnalyticsService.eventEmitter(
      SharedConsts.PRODCAT_MY_RANGE_FILTER_APPLIED_EVENT,
      SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
      SharedConsts.PRODCAT_MY_RANGE_FILTER_APPLIED_EVENT_ACTION,
      SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
      SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
    );

    this.emitFilterValues('range', this.range);
  }

  //-----------------on pmp filter select--------------------------------------------------
  onSelectPmp(selectedPmpId: any): void {
    this.filterSelectedValues.selectedPmpProductValue = selectedPmpId;
    let list_value = { 0: '', 1: '1', 2: '0' };
    this.saveFilterToStorage(
      'price_marked',
      list_value[selectedPmpId].toString()
    );

    this.googleAnalyticsService.eventEmitter(
      SharedConsts.PRODCAT_PMP_PRODUCTS_FILTER_APPLIED_EVENT,
      SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
      SharedConsts.PRODCAT_PMP_PRODUCTS_FILTER_APPLIED_EVENT_ACTION,
      SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
      SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
    );

    this.emitFilterValues('price_marked', list_value[selectedPmpId].toString());
  }

  //-----------------on promotion filter select--------------------------------------------------
  onSelectPromotion(selectedPromotionId: any, selectedPromotionName): void {
    this.saveFilterToStorage('promotion_filter', selectedPromotionId);

    this.statePersist.setLocalStorage(
      'promotion_tag_name',
      selectedPromotionName
    );

    this.googleAnalyticsService.eventEmitter(
      SharedConsts.PRODCAT_PROMOTION_FILTER_APPLIED_EVENT,
      SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
      SharedConsts.PRODCAT_PROMOTION_FILTER_APPLIED_EVENT_ACTION,
      SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
      SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
    );

    this.filterSelectedValues.promotionSelected = selectedPromotionId;

    this.emitFilterValues('promotion_filter', selectedPromotionId);
  }

  //-----------------on brand filter select--------------------------------------------------
  onSelectBrand(value): void {
    this.saveFilterToStorage('brand_filter', value);

    this.googleAnalyticsService.eventEmitter(
      SharedConsts.PRODCAT_BRAND_FILTER_APPLIED_EVENT,
      SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
      SharedConsts.PRODCAT_BRAND_FILTER_APPLIED_EVENT_ACTION,
      SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
      SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
    );
    this.filterSelectedValues.brandSelected = value;

    if (this.activatedRoute.queryParams['_value']['brandId']) {
      this.router.navigate([], {
        queryParams: { brandId: value }, // <-- clear all
        queryParamsHandling: '', // <-- do NOT preserve any existing query params
      });
      this.emitFilterValues('brand_filter', value);
    } else {
      this.emitFilterValues('brand_filter', value, true);
      this.onEmitAppliedTagNames();
    }
  }

  //------------------rsp filter handler--------------------------------------------------------
  rspFilter(maxValue, minValue): void {
    this.googleAnalyticsService.eventEmitter(
      SharedConsts.PRODCAT_RSP_FILTER_APPLIED_EVENT,
      SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
      SharedConsts.PRODCAT_RSP_FILTER_APPLIED_EVENT_ACTION,
      SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
      SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
    );
    4;

    const value = { maxValue, minValue };
    this.saveFilterToStorage('rsp_min', minValue);
    this.saveFilterToStorage('rsp_max', maxValue);
    this.emitFilterValues('rsp_min', value);
  }

  //-------------------applied emitted value to parent component-------------------------------------
  emitFilterValues(
    keyName: string,
    value: any,
    hasBrandRef: boolean = false
  ): void {
    switch (keyName) {
      case 'price_marked':
        this.filterTagNames = {
          ...this.filterTagNames,
          pmpTagName: this.createTagForPmp(),
        };
        this.filterInitialState = {
          ...this.filterInitialState,
          price_marked: value,
        };

        break;
      case 'promotion_filter':
        this.filterTagNames = {
          ...this.filterTagNames,
          promotionTagName: this.createTagForPromotions(),
        };
        this.filterInitialState = {
          ...this.filterInitialState,
          promotion_filter: value,
        };
        break;

      case 'brand_filter':
        this.filterTagNames = {
          ...this.filterTagNames,
          brandTagName: this.createTagForSelectedBrand(),
        };
        this.filterInitialState = {
          ...this.filterInitialState,
          brand_filter: value,
        };
        break;

      case 'range':
        this.filterInitialState = { ...this.filterInitialState, range: value };
        break;

      case 'rsp_min':
        this.filterInitialState = {
          ...this.filterInitialState,
          rsp_min: value?.minValue,
          rsp_max: value?.maxValue,
        };
        break;
    }

    let payload = { ...this.filterInitialState, page: 1 };
    if (keyName != 'brand_filter') {
      this.emitFiltersApplied.emit({
        filterState: payload,
        isRefresh: true,
        isFiltersApplied: true,
      });
    } else if (keyName == 'brand_filter' && hasBrandRef) {
      this.emitFiltersApplied.emit({
        filterState: payload,
        isRefresh: true,
        isFiltersApplied: true,
      });
    }
    this.onEmitAppliedTagNames();
    this.checkFilterCount();
  }

  //----------------------------emit tags applied------------------------------------------
  onEmitAppliedTagNames(): void {
    this.emitTagNamesApplied.emit(this.filterTagNames);
  }

  //----------------------create brand tag--------------------------------------
  createTagForSelectedBrand(): string {
    let selectedBrandTagName: string;
    if (this.filterSelectedValues.brandSelected) {
      const findSelectedBrand = this.brandFilter.find(
        (e) => e.id == this.filterSelectedValues.brandSelected
      );
      findSelectedBrand?.label
        ? (selectedBrandTagName = findSelectedBrand?.label)
        : '';
    } else {
      selectedBrandTagName = '';
    }
    return selectedBrandTagName;
  }

  //----------------------create pmp tag--------------------------------------
  createTagForPmp(): string {
    let selectedPmpTag: string;
    if (this.filterSelectedValues.selectedPmpProductValue != 0) {
      const findSelectedPmp = this.pmpProduct.find(
        (e) => e.id == this.filterSelectedValues.selectedPmpProductValue
      );
      if (findSelectedPmp?.name) {
        selectedPmpTag = findSelectedPmp?.name;
      }
    } else {
      selectedPmpTag = '';
    }

    return selectedPmpTag;
  }

  //----------------------create promotions tag--------------------------------------
  createTagForPromotions(): string {
    let selectedPromotionsTagName: string;

    if (this.filterSelectedValues.promotionSelected) {
      const findSelectedPromotions = this.promotionFilter.find(
        (e) => e.id == this.filterSelectedValues.promotionSelected
      );
      findSelectedPromotions?.name
        ? (selectedPromotionsTagName = findSelectedPromotions?.name)
        : '';
    } else {
      const promotionsName =
        this.statePersist.getLocalStorage('promotion_tag_name');

      selectedPromotionsTagName = promotionsName ? promotionsName : '';
    }

    return selectedPromotionsTagName;
  }

  //------------------search brands--------------------------------------------------
  getKeyUpEnterValue(event: any): void {
    if (event.key === 'Enter') {
      this.has_searched_text = true;
    }

    if (this.has_searched_text && event.target.value == '') {
      this.searchInput.next('');
    }

    if (event.target.value) {
      this.searchInput.next(event.target.value);
      this.has_searched_text = true;
    } else {
      this.searchInput.next('');
    }
  }

  //--------------------------clear search------------------------------------------
  onsearchClear(): void {
    this.searchInput.next('');
    this.searchBrandText = '';
  }

  openBrandsModal(): void {
    this.onViewAllBrands.emit('view');
  }

  //-----------------on filter clear all------------------------------------------
  onRemoveAllHandler(): void {
    this.filterSelectedValues.selectedPmpProductValue = 0;
    this.filterSelectedValues.promotionSelected = '';
    this.filterSelectedValues.brandSelected = '';
    this.filterSelectedValues.rspMinValue = this.defaultMinRspValue;
    this.filterSelectedValues.rspMaxValue = this.defaultMaxRspValue;
    this.filterSelectedValues.priceMarked = '';
    this.range = '';
    this.filterInitialState = {
      price_marked: '',
      rsp_min: '',
      rsp_max: '',
      page: 1,
      promotion_filter: '',
      brand_filter: '',
      range: '',
    };
    this.filterTagNames = {
      pmpTagName: '',
      brandTagName: '',
      promotionTagName: '',
    };

    this.emitTagNamesApplied.emit(this.filterTagNames);

    this.statePersist.setLocalStorage('product_data', { brand_filter: '' });
    if (this.activatedRoute.queryParams['_value']['brandId']) {
      this.resetQueryParamsForAppliedBrandFilter();
      this.emitFiltersApplied.emit({
        filterState: this.filterInitialState,
        isRefresh: false,
        isFiltercleared: true,
        isFiltersApplied: false,
      });
    } else {
      this.emitFiltersApplied.emit({
        filterState: this.filterInitialState,
        isRefresh: true,
        isFiltercleared: true,
        isFiltersApplied: false,
      });
    }
    this.checkFilterCount();
  }

  //--------------------------------------clear brand query param if in url------------------------------
  resetQueryParamsForAppliedBrandFilter(): void {
    this.saveFilterToStorage('brand_filter', '');
    if (this.activatedRoute.queryParams['_value']['brandId']) {
      this.router.navigate([], {
        queryParams: {}, // <-- clear all
        queryParamsHandling: '', // <-- do NOT preserve any existing query params
      });
    } else {
      this.emitFilterValues('brand_filter', '', true);
      this.filterSelectedValues.brandSelected = '';
      this.filterTagNames = { ...this.filterTagNames, brandTagName: '' };
      this.onEmitAppliedTagNames();
    }
  }

  //---------------------save data to local storage as per key value--------------------------------------------
  saveFilterToStorage(keyName: string, value: any): void {
    let productData = JSON.parse(
      JSON.stringify(this.statePersist.getLocalStorage('product_data'))
    );
    productData[keyName] = value;

    this.statePersist.setLocalStorage('product_data', productData);
  }

  //---------------------check total sidebar filter count-----------------------------------------------------
  checkFilterCount(): void {
    let count = 0;

    const individualKeys = [
      'selectedPmpProductValue',
      'promotionSelected',
      'brandSelected',
    ];
    individualKeys.forEach((key) => {
      if (
        this.filterSelectedValues[key] != '' &&
        this.filterSelectedValues[key] != 0
      ) {
        count++;
      }
    });

    // Check rspMinValue and rspMaxValue together as one
    if (
      (this.filterSelectedValues.rspMinValue != 0 &&
        this.filterSelectedValues.rspMaxValue != this.defaultMaxRspValue) ||
      (this.filterSelectedValues.rspMaxValue != 5 &&
        this.filterSelectedValues.rspMinValue != this.defaultMinRspValue)
    ) {
      count++;
    }

    if (this.range == '1') {
      count++;
    }

    this.filterSelected = count;
  }
}
